import React, { Component, ReactNode } from "react";
import brokenComputerIcon from "img/ErrorBoundary.png";
import { T } from "services/lang/LanguageService";

interface ErrorBoundaryProps {
  children: ReactNode;
  errorMessage?: string;
  isGroupHeader?: boolean;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.props.isGroupHeader) {
      return (
        <div className="flex flex-column align-items-center text-center justify-content-center">
          <img
            src={brokenComputerIcon}
            alt="Broken computer icon"
            style={{ width: "26px", height: "26px" }}
          />
        </div>
      );
    }

    if (this.state.hasError) {
      return (
        <div className="flex flex-column align-items-center text-center justify-content-center">
          <img
            src={brokenComputerIcon}
            alt="Broken computer icon"
            style={{ width: "100px", height: "100px" }}
          />
          <p className="text-xl font-bold">{this.props.errorMessage || T("error.something-went-wrong")}</p>
          <img
            src={brokenComputerIcon}
            alt="Broken computer icon"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
